import { GenericError, LoadingSpinner } from '@psyomics/ui-components';

import { SurveyBuilder } from './components/survey-builder';
import { useReferralRequestSurvey } from './hooks/use-referral-request-survey';

type ReferralRequestSurveyProps = { readonly referralRequestId: string; readonly reviewMode?: boolean };

const ReferralRequestSurvey = ({ referralRequestId, reviewMode = false }: ReferralRequestSurveyProps) => {
  const { survey, fetching } = useReferralRequestSurvey(referralRequestId);

  if (fetching) return <LoadingSpinner />;
  if (!survey) return <GenericError titleKey="common.errors.notFound" />;

  return <SurveyBuilder reviewMode={reviewMode} survey={survey} />;
};

export { ReferralRequestSurvey };
